"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.toolDef = void 0;
exports.handle = handle;
const fs = __importStar(require("fs-extra"));
const dist_1 = require("../../../fs/dist");
const getState_1 = require("../../../app/dist/getState");
const runEvent_1 = require("../../../app/dist/runEvent");
const recordRelease_1 = require("../../../app/dist/recordRelease");
exports.toolDef = {
    name: 'loom_record_release',
    description: 'Record the shipped release version onto done plans — plans are the single authoritative carrier of `actual_release`, and `current_release` is derived from them. Called by the project\'s release pipeline (Loom never reads package.json/git; you push the version in). Two modes: LIVE — pass `version` to stamp every done plan that has no release yet (between releases only the new ships are unstamped, so this is the auto-detect; idempotent, re-run is a no-op). BACKFILL — pass `releaseDates` (a version→tag-date map) to assign each done plan to the version whose date-range covers its done-date. Pass `version` OR `releaseDates`, not both. `overwrite` re-stamps already-stamped plans (the deliberate correction path, default false). Use this tool — do not edit plan files directly.',
    inputSchema: {
        type: 'object',
        properties: {
            version: {
                type: 'string',
                description: 'LIVE mode: the release version to stamp on every unstamped done plan, e.g. "1.9.3". Mutually exclusive with releaseDates.',
            },
            releaseDates: {
                type: 'array',
                description: 'BACKFILL mode: version→tag-date map. Each done plan is assigned to the version whose (prevDate, date] window covers its done-date. Mutually exclusive with version.',
                items: {
                    type: 'object',
                    properties: {
                        version: { type: 'string', description: 'Release version, e.g. "1.9.2".' },
                        date: { type: 'string', description: 'That release\'s tag date (YYYY-MM-DD).' },
                    },
                    required: ['version', 'date'],
                },
            },
            overwrite: {
                type: 'boolean',
                description: 'Re-stamp plans that already carry a release (deliberate correction). Default false.',
            },
        },
    },
};
async function handle(root, args) {
    const loadWeaveStrict = async (r, w) => {
        const result = await (0, dist_1.loadWeave)(r, w);
        if (!result)
            throw new Error(`Weave not found: ${w}`);
        return result;
    };
    const registry = new dist_1.ConfigRegistry();
    const deps = {
        loadState: () => (0, getState_1.getState)({ getActiveLoomRoot: dist_1.getActiveLoomRoot, loadWeave: dist_1.loadWeave, buildLinkIndex: dist_1.buildLinkIndex, registry, fs, workspaceRoot: root }),
        runEvent: (weaveSlug, event) => (0, runEvent_1.runEvent)(weaveSlug, event, { loadWeave: loadWeaveStrict, saveDocs: dist_1.saveDocs, loomRoot: root }),
    };
    const version = args['version'];
    const releaseDates = args['releaseDates'];
    const overwrite = args['overwrite'];
    if (version && releaseDates) {
        throw new Error('Pass either `version` (live) or `releaseDates` (backfill), not both.');
    }
    let result;
    if (releaseDates) {
        result = await (0, recordRelease_1.backfillReleases)({ releaseDates, overwrite }, deps);
    }
    else if (version) {
        result = await (0, recordRelease_1.recordRelease)({ version, overwrite }, deps);
    }
    else {
        throw new Error('loom_record_release requires either `version` (live) or `releaseDates` (backfill).');
    }
    return { content: [{ type: 'text', text: JSON.stringify(result) }] };
}
